export const countriesConstants = {
    GETALL_COUNTRIES: 'GETALL_COUNTRIES',
    GETALL_COUNTRIES_ALL: 'GETALL_COUNTRIES_ALL',
    GETALL_REGIONS: 'GETALL_REGIONS'
};
